import { useEffect } from 'react';
import AgentCard from '@/components/agents/AgentCard';
import { usePublicOwners } from '@/hooks/queries/useInvitationCodeQueries';

export default function AuthorizedAgentsPage() {
  useEffect(() => {
    // scroll to top smoothly when page loads
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const { data, isLoading: loading } = usePublicOwners();
  const agents = data?.owners ?? [];

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center pt-24">
        <div style={{ fontFamily: 'var(--ep-font-avenir)', color: '#767676' }}>Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white pt-24">
      <main className="w-full px-4 sm:px-6 py-8 sm:py-12">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col gap-6">
            <div className="w-full flex flex-col gap-2">
              <h1 className="text-[#113D7B] text-3xl font-bold">Authorized Agents</h1>
              <p className="text-[#4A5565] text-base">Connect with our trusted and verified agents</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {agents.map((agent, index) => (
                <AgentCard
                  key={index}
                  agentName={agent.owner_name}
                  agentEmail={agent.owner_email}
                  agentPhone={agent.owner_phone}
                  agentImage={agent.owner_image}
                />
              ))}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
